export default __webpack_public_path__ + "static/media/SWT0030.34I-27130_-25557_0.785f6efa.jpg";